module.exports = __webpack_public_path__ + "img/logoPrint.40ad6bd7.png";